import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { Typography, Color, Width } from '@figure/frontlib-gui';
import { numericFormatter } from '@figure/frontlib-util';
import { prettyPrintTerms } from 'shared/utils';
import { ProductName, ProductAPR, ProductButton, offerInfoType } from './shared';

const Container = styled.div`
  @media print, screen and (min-width: ${Width.SM}px) {
    display: none;
  }
`;
const ProductDetail = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid ${Color.GREY_3};

  :first-of-type {
    padding-top: 0px;
  }

  :last-of-type {
    border-bottom: none;
    margin-bottom: 16px;
  }
`;

const ProductHeading = styled(ProductDetail)`
  flex-direction: column;
  align-items: center;
`;

const ProductDetailText = styled(Typography.Body)`
  font-size: 1.3rem;
`;

const ProductDetailTextBold = styled(Typography.Body)`
  font-weight: 700;
`;

const Product = styled.div`
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 32px;

  ${({ highlight }) =>
    highlight &&
    css`
      background-color: #ddd8fd;

      * {
        color: ${Color.PURPLE_RAIN};
      }

      ${ProductDetail} {
        border-color: rgba(66, 54, 142, 0.24);
      }

      ${ProductButton} {
        background-color: ${Color.PURPLE_RAIN};
        color: ${Color.WHITE};
      }
    `}
`;

const MobileMultiProduct = ({ personalLoanOfferInfo, helocOfferInfo, handlePersonalLoanClick, handleHelocClick }) => (
  <Container>
    <Product>
      <ProductHeading>
        <ProductName>Personal Loan</ProductName>
        <ProductAPR>{numericFormatter.formatPercentage(personalLoanOfferInfo.apr, 100, 2)}</ProductAPR>
        <ProductDetailText>APRs starting at</ProductDetailText>
      </ProductHeading>

      <ProductDetail>
        <ProductDetailText>Max Loan Amount</ProductDetailText>
        <ProductDetailTextBold>{numericFormatter.formatMoney(personalLoanOfferInfo.maxAmount)}</ProductDetailTextBold>
      </ProductDetail>

      <ProductDetail>
        <ProductDetailText>Fastest Funding Time</ProductDetailText>
        <ProductDetailTextBold>2 days</ProductDetailTextBold>
      </ProductDetail>

      <ProductDetail>
        <ProductDetailText>Fixed Term Options</ProductDetailText>
        <ProductDetailTextBold>{prettyPrintTerms(personalLoanOfferInfo.terms, false)}</ProductDetailTextBold>
      </ProductDetail>
      <ProductButton onClick={handlePersonalLoanClick}>Explore offers</ProductButton>
    </Product>

    <Product highlight>
      <ProductHeading>
        <ProductName>Figure Home Equity Line</ProductName>
        <ProductAPR>{numericFormatter.formatPercentage(helocOfferInfo.apr, 100, 2)}</ProductAPR>
        <ProductDetailText>APRs starting at</ProductDetailText>
      </ProductHeading>

      <ProductDetail>
        <ProductDetailText>Max Loan Amount</ProductDetailText>
        <ProductDetailTextBold>{numericFormatter.formatMoney(helocOfferInfo.maxAmount)}</ProductDetailTextBold>
      </ProductDetail>

      <ProductDetail>
        <ProductDetailText>Fastest Funding Time</ProductDetailText>
        <ProductDetailTextBold>2 days</ProductDetailTextBold>
      </ProductDetail>

      <ProductDetail>
        <ProductDetailText>Fixed Term Options</ProductDetailText>
        <ProductDetailTextBold>{prettyPrintTerms(helocOfferInfo.terms, false)}</ProductDetailTextBold>
      </ProductDetail>
      <ProductButton onClick={handleHelocClick}>Explore offers</ProductButton>
    </Product>
  </Container>
);

MobileMultiProduct.propTypes = {
  personalLoanOfferInfo: offerInfoType.isRequired,
  helocOfferInfo: offerInfoType.isRequired,
  handlePersonalLoanClick: PropTypes.func.isRequired,
  handleHelocClick: PropTypes.func.isRequired,
};

export default MobileMultiProduct;
